export const // eslint-disable-line one-var
  /*
   * VALID_MSISDN_REGEX regex below ensures the text follows the following pattern:
   * Has 10 or 14 digits before the comma if it starts with 0
   * Has 11 or 12 digits before the comma if it starts with a +
   * VALID_MSISDN_WITH_DESCRIPTION_REGEX adds the following:
   * The comma is optional and indicates whether or not a description is added.
   * The description can have one leading space or not, and consist of any non-whitespace
   * character and a space.
   */
  VALID_MSISDN_REGEX = /^(?:[0-9]{10}|[0-9]{13,14}|\+[0-9]{11,12})$/,
  VALID_MSISDN_WITH_DESCRIPTION_REGEX = /^(?:[0-9]{10}|[0-9]{13,14}|\+[0-9]{11,12})(, ?.+)?$/,
  VALID_ICCID_REGEX = /^\d{19}$/,
  VALID_ICCID_WITH_DESCRIPTION_REGEX = /^(\d{19})(, ?.+)?$/,

  AIRTIME = 'AIRTIME',
  DATA = 'DATA',
  SMS = 'SMS',

  RECHARGE_TYPES = {
    AIRTIME,
    DATA,
    SMS,
  },

  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  SUBMITTED = 'SUBMITTED',

  RECHARGE_STATUSES = {
    SUCCESS,
    FAILED,
    SUBMITTED,
  },

  ASSIGNED = 'ASSIGNED',
  CANCELLED = 'CANCELLED',
  UNASSIGNED = 'UNASSIGNED',

  PAYMENT_STATUSES = {
    ASSIGNED,
    CANCELLED,
    UNASSIGNED,
  },

  INVALID_MSISDN = 'Invalid MSISDN',
  NETWORK_NOT_FOUND = 'Network Not Found',
  PRODUCT_TYPE_NOT_SUPPORTED = 'Network Does Not Support that Product Type',
  INVALID_RECHARGE_AMOUNT = 'No Product with that Amount on Network',
  MULTIPLE_PRODUCTS = 'Choose a product',

  ADHOC_RECHARGE_ERRORS = {
    INVALID_MSISDN,
    NETWORK_NOT_FOUND,
    PRODUCT_TYPE_NOT_SUPPORTED,
    INVALID_RECHARGE_AMOUNT,
    MULTIPLE_PRODUCTS,
  },

  SCALAR = 'SCALAR',
  INPUT_OBJECT = 'INPUT_OBJECT',
  OBJECT = 'OBJECT',
  ENUM = 'ENUM',
  UNION = 'UNION',
  INTERFACE = 'INTERFACE',
  MUTATION = 'MUTATION',

  GRAPHQL_API_TYPES = {
    SCALAR,
    INPUT_OBJECT,
    OBJECT,
    ENUM,
    UNION,
    INTERFACE,
    MUTATION,
  },

  // Onboarding stages
  ORDER_SIMS = 'ORDER_SIMS',
  ADD_RULES = 'ADD_RULES',
  ADD_SIMS = 'ADD_SIMS',
  FUND_ACCOUNT = 'FUND_ACCOUNT',

  ONBOARDING_STAGES = {
    ORDER_SIMS,
    ADD_RULES,
    ADD_SIMS,
    FUND_ACCOUNT,
  },

  // Rule types
  USAGE = 'USAGE',
  SCHEDULE = 'SCHEDULE',

  // Analytics constants
  BEGIN_STAGE = 'Begin stage',
  ONBOARDING_WORKFLOW = 'Onboarding workflow',
  SKIP_STAGE = 'Skip stage',
  SKIP_ONBOARDING = 'Skip onboarding',
  COMPLETE_ONBOARDING = 'Complete Onboarding',
  REQUEST_INVOICE = 'Request proforma invoice',
  REQUEST_HELP_WITH_MSISDN = 'Request help with MSISDN',
  EVENT = 'event',

  ANALYTICS_ACTIONS = {
    BEGIN_STAGE,
    SKIP_STAGE,
    SKIP_ONBOARDING,
    COMPLETE_ONBOARDING,
    REQUEST_INVOICE,
    REQUEST_HELP_WITH_MSISDN,
  },

  // Fee types
  ADDITION_FEE = 'ADDITION_FEE',
  MANAGEMENT_FEE = 'MANAGEMENT_FEE',

  // Credit card types
  MASTERCARD = 'mastercard',
  VISA = 'visa',

  // LBS
  NO_HISTORY_AVAILABLE = 'No history available',
  LAST_KNOWN_LOCATION = 'Last known location',
  PHONE_LOCATED = 'Phone located';
